import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ScreenState {
    currentScreen: string;
    }

const initialState: ScreenState = {
    currentScreen: "Staff"
};

export const screenSlice = createSlice({
    name: 'screen',
    initialState,
    reducers: {
        updateScreen: (state, action: PayloadAction<string>) => {
            state.currentScreen = action.payload;
        },
    },
});

export const { updateScreen } = screenSlice.actions;
export default screenSlice.reducer;